export const NOT_AVAILABLE = 'N/A'

export const severityOrder: Record<string, number> = {
    critical: 4,
    high: 3,
    medium: 2,
    low: 1,
    info: 0,
}

export const statusOrder: Record<string, number> = {
    waiting: 2,
    inprogress: 1,
    closed: 0,
    open: -1,
}

export const compareSeverity = (a: string = '', b: string = ''): number => {
    const aSeverity = a.toLowerCase()
    const bSeverity = b.toLowerCase()
    return (severityOrder[aSeverity] ?? -1) - (severityOrder[bSeverity] ?? -1)
}

export const compareStatus = (a: string = '', b: string = ''): number => {
    const aStatus = a.toLowerCase()
    const bStatus = b.toLowerCase()
    return (statusOrder[aStatus] ?? -2) - (statusOrder[bStatus] ?? -2)
}

export const compareDate = (a: string = '', b: string = ''): number =>
    new Date(b).getTime() - new Date(a).getTime()

export const statusLabelMap: Record<TStatus, string> = {
    waiting: 'Waiting for Response',
    inprogress: 'In Progress',
    closed: 'Closed',
    open: 'Open',
}

export const statusLabelMapServiceRequests: Record<TStatus, string> = {
    waiting: 'Waiting',
    inprogress: 'In Progress',
    closed: 'Closed',
    open: 'Open',
}

export type TStatus = 'waiting' | 'inprogress' | 'closed' | 'open'

export const columnSortingConfig: Record<string, boolean> = {
    severity: true,
    title: false,
    status: true,
    createdAt: true,
    disposition: true,
    caseSource: false,
}

export const sortStrategies: Record<string, (a: any, b: any) => number> = {
    incidents: (a, b) => {
        const statusDiff = compareStatus(b.status, a.status)
        if (statusDiff !== 0) return statusDiff
        const severityDiff = -compareSeverity(a.severity, b.severity)
        if (severityDiff !== 0) return severityDiff
        return compareDate(a.createdAt, b.createdAt)
    },
    alerts: (a, b) => {
        const statusDiff = compareStatus(a.status, b.status)
        if (statusDiff !== 0) return statusDiff
        return compareDate(a.createdAt, b.createdAt)
    },
    serviceRequests: (a, b) => {
        const statusDiff = -compareStatus(a.status, b.status)
        if (statusDiff !== 0) return statusDiff
        return compareDate(a.createdAt, b.createdAt)
    },
}
